import PartnerLayout from "../../components/layout/partnerLayout";
import MobilePartnerShell from "../shell/MobilePartnerShell";
import { useIsMobile } from "../hooks/useIsMobile";
import usePartnerStoreSync from "../../context/usePartnerStoreSync";

function AdaptivePartnerLayout() {
  const isMobile = useIsMobile();
  usePartnerStoreSync();
  return isMobile ? <MobilePartnerShell /> : <PartnerLayout />;
}

export default AdaptivePartnerLayout;
